import { createReducer } from '@reduxjs/toolkit';
import { loginAction, logoutAction } from './sessaoActions';
import { SessaoState } from './sessaoTypes';

export const initialState: SessaoState = {
  token: null,
  cliente: null
};

const sessaoReducer = createReducer(initialState, {
  [loginAction.toString()]: (state, action) => {
    if (loginAction.match(action)) {
      return { ...state, ...action.payload };
    }
  },
  [logoutAction.toString()]: (state, action) => {
    return initialState;
  }
});

export default sessaoReducer;
